var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.418 18.75h2.5v-7.5h-2.5v7.5zM12.668 0C5.765 0 .169 5.596.169 12.5c0 6.906 5.596 12.502 12.5 12.502 6.906 0 12.502-5.596 12.502-12.501C25.166 5.598 19.57 0 12.669 0zm0 22.5c-5.522 0-9.999-4.478-9.999-10 0-5.52 4.477-10 10-10s10 4.478 10 10c-.008 5.519-4.48 9.992-10 9.999v.002zm-1.25-13.75h2.5v-2.5h-2.5v2.5z",
    fill: "#4A3D32"
  })));
}

export default SvgNotification;